import React, { useState } from 'react';
import Panel from '../../components/ui/Panel';
import Tabs from '../../components/ui/Tabs';

const tabs = [
  { id: 'inventory', label: 'Inventory' },
  { id: 'equipment', label: 'Equipment' },
  { id: 'skills', label: 'Skills' },
  { id: 'quests', label: 'Quests' },
];

const copy: Record<string, string> = {
  inventory: '28 slots in 4 columns.',
  equipment: 'Worn items and combat stats.',
  skills: 'Levels and experience.',
  quests: 'The quest list.',
};

const NavigationTabs: React.FC = () => {
  const [active, setActive] = useState('inventory');

  return (
    <div className="space-y-8">
      <h1 id="overview" className="text-3xl text-osrs-gold font-bold uppercase mb-4">Navigation Tabs</h1>
      <Panel>
        <p className="text-osrs-yellow mb-4">
          The selected tab is the lighter stone. The others stay dark. This is the same control as the chat channel row.
        </p>
        <Tabs tabs={tabs} value={active} onChange={setActive} label="Side panels" />
        <p className="text-osrs-yellow mt-4">{copy[active]}</p>
      </Panel>
    </div>
  );
};

export default NavigationTabs;
